import React from 'react';
import { SvgIcon } from '@mui/material';

// Bare Knuckle icon factory. Every FightDecks icon is built through this so the
// construction rules are enforced in ONE place: 24×24 grid, currentColor stroke,
// 2px weight, butt caps, miter joins, no fill. Icon geometry (`children`) is just
// <path d="…"/> / <line/> etc. — the stroke props inherit from here, guaranteeing
// a single visual weight across the set. Consumers set emphasis via color
// (text.primary vs text.secondary) — never inside the icon.
export const createFdIcon = (children, displayName) => {
  const C = (props) => (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        ...props.sx,
      }}
    >
      {children}
    </SvgIcon>
  );
  C.displayName = displayName;
  return C;
};

export default createFdIcon;
